export const getItemObjectFromLocalStorage = key => {
  const item = localStorage.getItem(key);

  return item ? JSON.parse(item) : {};
};

export const setItemObjectToLocalStorage = (key, object) => {
  return localStorage.setItem(key, JSON.stringify(object));
};